<div class="d-flex h-100">
    <div *ngFor="let menuItem of menu" class="top-item">
        <app-dn-user-menu-item class="user-menu mx-2" [item]="menuItem" ></app-dn-user-menu-item>
    </div>
</div>
